export const addressTypes = {
  billing: 'billing',
  shipping: 'shipping',
};

export const deviceWidths = {
  phoneMaxWidth: 767,
  tabletMaxWidth: 1023,
};
